module.exports = __webpack_public_path__ + "static/media/no_panel_requests.f35e26b2.svg";